import insertNewQuestionnaire from '../data_management/insertNewQuestionnaire'
import extractSecretKey from '../data_management/extractSecretKey'
import deleteQuestionnaire from '../data_management/deleteQuestionnaire'

class QuestionnairesInteractor {
  constructor(initialDataInteractor, coachGateway) {
    this.initialDataInteractor = initialDataInteractor;
    this.coachGateway = coachGateway;
  }

  addNewQuestionnaire() {
    return this.coachGateway.createNewQuestionnaire(extractSecretKey(this.initialDataInteractor)).then(newQuestionnaireData => {
      insertNewQuestionnaire(this.initialDataInteractor, newQuestionnaireData);
      return newQuestionnaireData.questionnaire.id;
    });
  }

  deleteQuestionnaire(questionnaireId) {
    return this.coachGateway.deleteQuestionnaire(extractSecretKey(this.initialDataInteractor), questionnaireId)
      .then(() => deleteQuestionnaire(questionnaireId, this.initialDataInteractor));
  }

  duplicateQuestionnaire(questionnaireId) {
    return this.coachGateway.duplicateQuestionnaire(extractSecretKey(this.initialDataInteractor), questionnaireId);
  }

}

export default QuestionnairesInteractor